import React from 'react';

// Briques communes de la nouvelle fiche projet : même allure que l'accueil (cartes blanches arrondies, titres courts
// avec une icône grise, libellés en petites capitales).

export const Card = ({ title, icon: Icon, action, children, className = '', bodyClassName = '' }) => (
  <section className={`min-w-0 rounded-2xl border border-slate-200/80 bg-white shadow-sm ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between gap-3 px-4 pt-4 sm:px-5">
        {title && (
          <h2 className="flex min-w-0 items-center gap-2 text-sm font-semibold text-slate-800">
            {Icon && <Icon size={16} className="shrink-0 text-slate-400" />}
            <span className="truncate">{title}</span>
          </h2>
        )}
        {action && <div className="flex shrink-0 items-center gap-1">{action}</div>}
      </div>
    )}
    <div className={`px-4 pb-4 sm:px-5 ${title || action ? 'pt-3' : 'pt-4'} ${bodyClassName}`}>{children}</div>
  </section>
);

export const Label = ({ children, className = '' }) => (
  <p className={`text-[11px] font-semibold uppercase tracking-wide text-slate-400 ${className}`}>{children}</p>
);

export const GhostButton = ({ children, className = '', ...props }) => (
  <button type="button" {...props}
    className={`inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-xs font-semibold text-slate-500 hover:bg-slate-100 hover:text-slate-800 disabled:opacity-40 ${className}`}>
    {children}
  </button>
);

export const PrimaryButton = ({ children, className = '', ...props }) => (
  <button type="button" {...props}
    className={`inline-flex items-center gap-1.5 rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white hover:bg-slate-700 disabled:opacity-40 ${className}`}>
    {children}
  </button>
);

export const Empty = ({ children }) => (
  <p className="rounded-xl border border-dashed border-slate-200 px-3 py-4 text-center text-sm text-slate-400">{children}</p>
);

const dateOf = (iso) => new Date(`${String(iso).slice(0, 10)}T12:00:00`);

export const shortDate = (iso) => (iso ? new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' }).format(dateOf(iso)) : '');

export const longDate = (iso) => (iso ? new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).format(dateOf(iso)) : '');

export const daysBetween = (from, to) => Math.round((dateOf(to) - dateOf(from)) / 86400000);

export const euros = (value) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(value) || 0);

// CA produit (GET /steering) : le CA des itérations au % de réalisation saisi, une itération terminée comptant en entier.
export const producedHint = (ca) => (ca?.ca_eur > 0 ? `${Math.round((ca.ca_produced_eur / ca.ca_eur) * 100)} % du CA planifié` : 'pas de CA planifié');

export const toProduceHint = (ca) => (ca?.ca_eur > 0 ? `sur ${euros(ca.ca_eur)} planifiés` : 'pas de CA planifié');

export const hours = (value) => `${Number(value || 0).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} h`;

export const initials = (name) => String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase();

export const Avatar = ({ name, picture, size = 'h-7 w-7', className = '' }) => (picture ? (
  <img src={picture} alt={name} title={name} referrerPolicy="no-referrer" className={`${size} shrink-0 rounded-full object-cover ring-2 ring-white ${className}`} />
) : (
  <span title={name} className={`${size} flex shrink-0 items-center justify-center rounded-full bg-indigo-100 text-[11px] font-semibold text-indigo-700 ring-2 ring-white ${className}`}>
    {initials(name)}
  </span>
));
